import React from 'react';
import { ArrowUpDown, ChevronDown } from 'lucide-react';
import type { DataSourceConfig } from '@/services/PagesServices/CustomReportBuilderService';
import { useReportBuilderState } from '../hooks/useReportBuilderState';
import type { SortOrder } from '../constants';

interface SortSectionProps {
  currentSource: DataSourceConfig | undefined;
}

const SortSection: React.FC<SortSectionProps> = ({ currentSource }) => {
  const expanded = useReportBuilderState(s => s.expandedSections.sortGroup);
  const sortBy = useReportBuilderState(s => s.sortBy);
  const sortOrder = useReportBuilderState(s => s.sortOrder);
  const toggleSection = useReportBuilderState(s => s.toggleSection);
  const setSortBy = useReportBuilderState(s => s.setSortBy);
  const setSortOrder = useReportBuilderState(s => s.setSortOrder);

  return (
    <div className="crb-config-section">
      <div className="crb-config-header" onClick={() => toggleSection('sortGroup')}>
        <div className="crb-config-header-left">
          <ArrowUpDown size={18} />
          <span className="crb-config-header-title">Sort</span>
        </div>
        <ChevronDown size={16} className={`crb-config-chevron ${expanded ? 'open' : ''}`} />
      </div>

      {expanded && currentSource && (
        <div className="crb-config-body">
          <div className="crb-sort-group">
            <div className="crb-sort-row">
              <span className="crb-sort-label">Sort By</span>
              <select className="crb-sort-select" value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
                <option value="">None</option>
                {currentSource.fields.filter(f => f.sortable).map(f => (
                  <option key={f.key} value={f.key}>{f.label}</option>
                ))}
              </select>
            </div>
            {sortBy && (
              <div className="crb-sort-row">
                <span className="crb-sort-label">Order</span>
                <select
                  className="crb-sort-select"
                  value={sortOrder}
                  onChange={(e) => setSortOrder(e.target.value as SortOrder)}
                >
                  <option value="asc">Ascending</option>
                  <option value="desc">Descending</option>
                </select>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(SortSection);
